import { jsxs as t, jsx as p } from "react/jsx-runtime";
import { getErrorMessage as q } from "../shared/utils.js";
import { useState as l, useCallback as n } from "react";
import { Button as h } from "../shared/button/Button.component.js";
import { ButtonThemeEnum as x, ButtonShapeEnum as I, ButtonSizeEnum as A } from "../shared/button/types.js";
import { InputSizeEnum as b, InputThemeEnum as g } from "../shared/input/types.js";
import { LabeledTextInput as w } from "../shared/labeled-text-input/LabeledTextInput.component.js";
import { Spinner as F } from "../shared/spinner/Spinner.component.js";
import { SpinnerThemeEnum as U } from "../shared/spinner/types.js";
import { b as D } from "../bg-auth-C3Esb6O0.js";
import { defaultCopies as H } from "./default-copies.js";
import { AuthFooter as M } from "./AuthFooter.component.js";
import { AuthHeader as G } from "./AuthHeader.component.js";
const ap = ({
  onLogin: s,
  copies: i = H,
  onSignupClick: y,
  onForgotPasswordClick: v,
  imprintUrl: N,
  termsOfServiceUrl: C,
  privacyPolicyUrl: k,
  currentLang: E,
  langOptions: S,
  onLangChange: z
}) => {
  const [o, T] = l(""), [r, j] = l(""), [d, m] = l(null), [u, c] = l(!1), B = n(
    async (e) => {
      e.preventDefault();
      try {
        c(!0), await s({
          username: o,
          password: r
        });
      } catch (f) {
        console.error(f), m(q(f));
      } finally {
        c(!1);
      }
    },
    [o, s, r]
  ), P = n(
    (e) => {
      T(e.target.value), m(null);
    },
    []
  ), L = n(
    (e) => {
      j(e.target.value), m(null);
    },
    []
  ), a = i.login;
  return /* @__PURE__ */ t("div", { className: "app:flex app:flex-col app:md:flex-row app:h-[100svh] app:relative app:items-stretch", children: [
    /* @__PURE__ */ p(
      G,
      {
        buttonText: a.signUp,
        onButtonClick: y
      }
    ),
    /* @__PURE__ */ t("div", { className: "app:w-full app:md:flex-1 app:flex app:flex-col app:relative app:justify-end app:text-left app:font-normal app:aspect-square app:md:aspect-auto", children: [
      /* @__PURE__ */ p(
        "img",
        {
          src: D,
          className: "app:aspect-square app:w-full app:object-cover app:md:aspect-auto app:flex-1 app:absolute app:md:w-full app:md:h-full app:md:z-0 "
        }
      ),
      /* @__PURE__ */ p("p", { className: "app:text-sm app:md:text-lg app:text-neutral app:relative app:z-10 app:px-6 app:md:px-10 app:mb-3 app:mt-0 app:hidden app:md:block", children: a.quote }),
      /* @__PURE__ */ p("p", { className: "app:text-sm app:text-neutral app:relative app:z-10 app:px-6 app:md:px-10 app:pb-6 app:md:pb-10 app:my-0 app:hidden app:md:block app:opacity-50", children: a.quoteAuthor })
    ] }),
    /* @__PURE__ */ t(
      "form",
      {
        onSubmit: B,
        className: "app:md:flex-1 app:flex app:flex-col app:justify-between app:px-6 app:py-8 app:md:px-10 app:md:py-10 app:md:pt-24 app:overflow-visible app:md:overflow-y-auto",
        children: [
          /* @__PURE__ */ t("div", { className: "app:w-full app:md:max-w-sm app:mx-auto app:flex app:flex-col app:text-left app:flex-1 app:justify-center", children: [
            /* @__PURE__ */ p("h1", { className: "app:text-3xl app:font-bold app:mb-3 app:mt-0 app:md:block", children: a.title }),
            /* @__PURE__ */ p("p", { className: "app:text-md app:text-primary/60 app:mb-8 app:mt-0 app:md:block", children: a.subtitle }),
            /* @__PURE__ */ p(
              w,
              {
                labelText: a.emailLabel,
                value: o,
                onChange: P,
                placeholder: a.emailPlaceholder,
                type: "email",
                id: "email",
                error: null,
                inputTheme: g.secondary,
                inputSize: b.sm,
                containerClassName: "app:w-full app:mb-6"
              }
            ),
            /* @__PURE__ */ p(
              w,
              {
                labelText: a.passwordLabel,
                value: r,
                onChange: L,
                placeholder: a.passwordPlaceholder,
                type: "password",
                id: "password",
                error: null,
                inputTheme: g.secondary,
                inputSize: b.sm,
                containerClassName: "app:w-full app:mb-2"
              }
            ),
            /* @__PURE__ */ p(
              h,
              {
                type: "button",
                theme: x.naked,
                className: "app:ml-auto app:[--button--min-width--md:0px] app:[--button--padding:8px] app:[--button--color--naked:var(--app-color-muted)] app:[--button--font-weight--md:400] app:font-normal app:[--button--height--md:auto] app:mb-6 app:[--button--font-size--md:14px] app:-mr-2",
                onClick: v,
                "data-testid": "resetPasswordButton",
                children: a.forgotPassword
              }
            ),
            /* @__PURE__ */ p(
              h,
              {
                type: "submit",
                theme: x.primary,
                size: A.md,
                shape: I.pill,
                disabled: u,
                "data-testid": "login-button",
                children: u ? /* @__PURE__ */ p(
                  F,
                  {
                    theme: U.negated,
                    className: "app:w-6 app:h-6"
                  }
                ) : a.login
              }
            ),
            d ? /* @__PURE__ */ p(
              "p",
              {
                className: "app:text-sm app:text-danger app:mt-8 app:text-center app:min-h-9 app:bg-danger/5 app:py-2 app:px-4 app:rounded-lg app:flex app:items-center app:mx-auto app:leading-[1] app:box-border",
                "data-testid": "error-alert",
                role: "alert",
                children: d
              }
            ) : /* @__PURE__ */ p("div", { className: "app:h-9" })
          ] }),
          /* @__PURE__ */ p("div", { className: "app:bg-primary/10 app:w-full app:h-px app:mt-8 app:md:hidden" }),
          /* @__PURE__ */ p(
            M,
            {
              currentLang: E,
              langOptions: S,
              onLangChange: z,
              copies: i.authFooter,
              imprintUrl: N,
              termsOfServiceUrl: C,
              privacyPolicyUrl: k
            }
          )
        ]
      }
    )
  ] });
};
export {
  ap as Login
};
